import { actions } from './slices';
import * as thunks from './thunks';

export const NavigationActions = {
  ...actions,
  ...thunks,
};
